var map = {
	"./custom/app/item-page/media-viewer/media-viewer.component": [
		1077,
		[
			"default-src_app_item-page_media-viewer_media-viewer_component_ts",
			"src_themes_custom_app_item-page_media-viewer_media-viewer_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5452;
module.exports = webpackAsyncContext;